/* ==========================================================================
   SS CART REWARDS controller. 2026-09-02, RJ item 9.

   Reads the cart, moves two bars, and applies the earned Fuel code.

   THREE RULES
   1. Never invent a saving. The free-delivery threshold and the ladder
      codes are Shopify's own (verified live 2026-09-02). A code is applied
      through /cart/update.js and the cart's own response says whether it
      took; if Shopify says "not applicable" the text says "use FUELBOX8 at
      checkout" and claims nothing.
   2. Never race the theme. The theme's cart components fetch, dispatch
      cart:update and morph their own section. This file listens for that
      event, then reads /cart.js (or the cart object riding on the event),
      so it always paints AFTER the platform, never instead of it.
   3. Celebrate once. A rung fires its sweep on the transition below->above,
      not on every repaint, or holding + becomes a strobe.

   Delegated everywhere: the cart drawer is morphed on every change, so the
   block is looked up fresh on every paint and nothing is cached on nodes.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var last = { total: null, bowls: null, tierMin: -1, shipWon: null };
  var applying = null;   /* code currently being applied, or null */
  var refused = {};      /* codes Shopify said were not applicable this session */
  var busy = false;

  function rupees(paise) {
    var n = Math.round(paise / 100);
    return '\u20B9' + n.toLocaleString('en-IN');
  }
  function replay(el, cls, ms) {
    if (!el || reduce) return;
    el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, ms || 800);
  }
  function tick() {
    if (reduce) return;
    try { if (navigator.vibrate && window.matchMedia('(pointer: coarse)').matches) navigator.vibrate(14); } catch (e) {}
  }

  function parseTiers(raw) {
    return (raw || '').split(',').map(function (s) {
      var p = s.trim().split(':');
      var min = parseInt(p[0], 10), pct = parseInt(p[1], 10), code = (p[2] || '').trim();
      if (!min || !pct || !code) return null;
      return { min: min, pct: pct, code: code };
    }).filter(Boolean).sort(function (a, b) { return a.min - b.min; });
  }

  function blocks() { return [].slice.call(document.querySelectorAll('[data-ss-rewards]')); }

  /* ---- paint ---------------------------------------------------------- */
  function paint(cart, opts) {
    opts = opts || {};
    var total = cart.total_price;
    var bowls = 0;
    var codes = [];
    (cart.items || []).forEach(function (it) {
      if (it.product_type && it.product_type.indexOf('Bowl') !== -1) bowls += it.quantity;
    });
    (cart.discount_codes || []).forEach(function (d) { if (d.applicable) codes.push(d.code); });
    /* /cart/add.js style responses have no discount_codes: fall back to the server-rendered list */
    var first = blocks()[0];
    if (!cart.discount_codes && first) codes = (first.getAttribute('data-codes') || '').split(',').filter(Boolean);

    blocks().forEach(function (root) {
      root.classList.remove('is-loading');
      var freeShip = parseInt(root.getAttribute('data-free-ship'), 10) || 0;
      var tiers = parseTiers(root.getAttribute('data-tiers'));

      /* rung 1: delivery */
      var shipRow = root.querySelector('[data-rw-ship]');
      var shipFill = root.querySelector('[data-rw-ship-fill]');
      var shipText = root.querySelector('[data-rw-ship-text]');
      var won = freeShip > 0 && total >= freeShip;
      if (shipFill) shipFill.style.width = (freeShip ? Math.min(100, total / freeShip * 100) : 0) + '%';
      if (shipText) {
        if (!cart.item_count) shipText.innerHTML = 'Free delivery on orders over ' + rupees(freeShip);
        else if (won) shipText.innerHTML = '<strong>Free delivery</strong> unlocked';
        else shipText.innerHTML = '<strong>' + rupees(freeShip - total) + '</strong> more for free delivery';
      }
      if (shipRow) {
        shipRow.classList.toggle('is-won', won);
        if (won && last.shipWon === false) { replay(shipRow, 'is-sweeping'); replay(shipRow, 'is-flash'); tick(); }
      }

      /* rung 2: the Fuel ladder */
      var row = root.querySelector('[data-rw-stack]');
      if (!row) return;
      if (!bowls || !tiers.length) { row.hidden = true; root.classList.remove('ss-rewards--has-fuel'); return; }
      row.hidden = false;
      root.classList.add('ss-rewards--has-fuel');
      var tier = null, next = null;
      tiers.forEach(function (t) { if (bowls >= t.min) tier = t; });
      for (var i = 0; i < tiers.length; i++) if (bowls < tiers[i].min) { next = tiers[i]; break; }
      var top = tiers[tiers.length - 1].min;
      var fill = row.querySelector('[data-rw-stack-fill]');
      if (fill) fill.style.width = Math.min(100, bowls / top * 100) + '%';
      var pips = row.querySelector('[data-rw-stack-pips]');
      if (pips && !pips.children.length) {
        tiers.forEach(function (t) {
          var p = document.createElement('span');
          p.className = 'ss-rewards__pip';
          p.setAttribute('data-pip-min', String(t.min));
          p.style.left = Math.min(99, t.min / top * 100) + '%';
          pips.appendChild(p);
        });
      }
      if (pips) [].forEach.call(pips.children, function (p) {
        p.classList.toggle('is-hit', bowls >= parseInt(p.getAttribute('data-pip-min'), 10));
      });

      var text = row.querySelector('[data-rw-stack-text]');
      var btn = row.querySelector('[data-rw-apply]');
      var applied = tier && codes.indexOf(tier.code) !== -1;
      var html = '';
      if (tier) {
        html = '<strong>' + tier.pct + '% off</strong> ' + bowls + ' Fuel ' + (bowls === 1 ? 'box' : 'boxes');
        if (applying === tier.code) html += ', applying...';
        else if (applied) html += ', applied <span class="ss-rewards__code">' + tier.code + '</span>';
        else if (refused[tier.code]) html += '. Use <span class="ss-rewards__code">' + tier.code + '</span> at checkout';
        else html += ' unlocked';
        if (next) html += '. ' + (next.min - bowls) + ' more for ' + next.pct + '%';
      } else if (next) {
        html = '<strong>' + (next.min - bowls) + ' more ' + (next.min - bowls === 1 ? 'box' : 'boxes') + '</strong> for ' + next.pct + '% off your Fuel boxes';
      }
      if (text) text.innerHTML = html;
      row.classList.toggle('is-won', !!tier);
      if (btn) {
        btn.hidden = !(tier && !applied && !applying && refused[tier.code]);
        if (tier) { btn.textContent = 'Apply ' + tier.pct + '% off'; btn.setAttribute('data-code', tier.code); }
      }
      var tierMin = tier ? tier.min : -1;
      if (tier && tierMin > last.tierMin && last.tierMin !== null && opts.live) {
        replay(row, 'is-sweeping'); replay(row, 'is-flash'); tick();
        var pip = pips ? pips.querySelector('[data-pip-min="' + tier.min + '"]') : null;
        replay(pip, 'is-hit', 1200);
      }
      /* instant gratification: the earned code goes on by itself, once */
      if (tier && !applied && !applying && !refused[tier.code] && !opts.noApply) apply(tier.code, codes);
    });

    last.total = total; last.bowls = bowls; last.shipWon = freeShip > 0 && total >= freeShip;
    var tm = -1; blocks().forEach(function (root) {
      var tiers = parseTiers(root.getAttribute('data-tiers'));
      tiers.forEach(function (t) { if (bowls >= t.min) tm = Math.max(tm, t.min); });
    });
    last.tierMin = tm;
  }

  /* ---- apply a code through the platform ------------------------------- */
  function sectionId() {
    var c = document.querySelector('cart-items-component[data-section-id]');
    return c ? c.getAttribute('data-section-id') : null;
  }
  function apply(code, existing) {
    var root = blocks()[0];
    if (!root) return;
    applying = code;
    root.classList.add('is-loading');
    var keep = (existing || []).filter(function (c) { return !/^FUELBOX/i.test(c); });
    var body = { discount: keep.concat(code).join(',') };
    var sid = sectionId();
    if (sid) body.sections = [sid];
    fetch(root.getAttribute('data-cart-update-url') || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (cart) {
      applying = null;
      var ok = (cart.discount_codes || []).some(function (d) { return d.code === code && d.applicable; });
      if (!ok) refused[code] = true;
      /* refresh the platform's own totals from the section it rendered */
      if (ok && sid && cart.sections && cart.sections[sid]) morphSummary(sid, cart.sections[sid]);
      paint(cart, { live: false, noApply: true });
      if (ok) { var row = document.querySelector('[data-rw-stack]'); replay(row, 'is-flash'); }
    }).catch(function () {
      applying = null;
      refused[code] = true;
      var r = blocks()[0]; if (r) r.classList.remove('is-loading');
    });
  }
  function morphSummary(sid, html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-drawer__summary, .cart__summary, .cart-summary, .cart-totals');
      var mine = document.querySelector('.cart-drawer__summary, .cart__summary, .cart-summary, .cart-totals');
      if (fresh && mine) mine.innerHTML = fresh.innerHTML;
    } catch (e) { /* the totals refresh on the next platform morph */ }
  }

  /* ---- read the cart ---------------------------------------------------- */
  function refresh(evt) {
    var root = blocks()[0];
    if (!root) return;
    root.classList.add('is-loading');
    var res = evt && evt.detail && evt.detail.resource;
    if (res && typeof res.total_price === 'number' && res.items) { paint(res, { live: true }); return; }
    if (busy) return;
    busy = true;
    fetch((root.getAttribute('data-cart-url') || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { busy = false; paint(cart, { live: true }); })
      .catch(function () { busy = false; var r = blocks()[0]; if (r) r.classList.remove('is-loading'); });
  }

  /* first paint from the server-rendered numbers, no fetch */
  function prime() {
    var root = blocks()[0];
    if (!root) return;
    var codes = (root.getAttribute('data-codes') || '').split(',').filter(Boolean);
    var bowls = parseInt(root.getAttribute('data-bowls'), 10) || 0;
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var items = bowls ? [{ product_type: 'Fuel Meal Bowl', quantity: bowls }] : [];
    last.shipWon = null; last.tierMin = null;
    paint({ total_price: total, items: items, item_count: items.length, discount_codes: codes.map(function (c) { return { code: c, applicable: true }; }) }, { live: false });
    last.tierMin = -1; blocks().forEach(function (r) { parseTiers(r.getAttribute('data-tiers')).forEach(function (t) { if (bowls >= t.min) last.tierMin = Math.max(last.tierMin, t.min); }); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rw-apply]') : null;
    if (!b) return;
    var code = b.getAttribute('data-code');
    if (!code) return;
    delete refused[code];
    apply(code, []);
  });

  document.addEventListener('cart:update', function (e) { setTimeout(function () { refresh(e); }, 60); });
  document.addEventListener('discount:update', function () { setTimeout(refresh, 60); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime);
  else prime();
})();
